import React, { Component } from "react";
import PropTypes from "prop-types";
import { Bar } from "react-chartjs-2";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actions from "../dashboardActions";
import {
  getLogsPerDay,
  getLogsPerDayHasErrors,
  getLogsPerDayIsLoading
} from "../dashboardSelector";
import WidgetErrorMessage from "./WidgetErrorMessage";
import Spinner from "../../common/progress/Spinner";
import Widget from "./Widget";
import translate from "react-i18next/dist/commonjs/translate";
import WidgetOverlayLinkToTa from "./WidgetOverlayLinkToTa";

export class LogsDayWidget extends Component {
  constructor(props) {
    super(props);
    this.onReload = this.onReload.bind(this);
  }

    componentDidMount() {
        if (this.props.customerInformation.siem != "wazuh") {
            this.props.actions.loadLogsPerDay();
        }
  }

  onReload() {
      if (this.props.customerInformation.siem != "wazuh") {
          this.props.actions.loadLogsPerDay();
      }
  }

  render() {
      const { customerInformation, isLoading, hasErrors, logsPerDay, t } = this.props;

    const options = {
      legend: {
        display: false
      },
      scales: {
        xAxes: [
          {
            gridLines: {
              display: false
            },
            scaleLabel: {
              display: true,
              labelString: "Date"
            }
          }
        ],
        yAxes: [
          {
            scaleLabel: {
              display: true,
              labelString: "Data (GB)"
            },
            ticks: {
              beginAtZero: true,
              maxTicksLimit: 5,
              callback: function(value, index, values) {
                if (Math.round(value * 10) / 10 === value) {
                  return value;
                }
              }
            }
          }
        ]
      },
      maintainAspectRatio: false
      };

      const datasetsMock = [
          {
              type: "bar",
              label: 0,
              data: [30,10, 7, 6, 11, 5, 20],
              backgroundColor: "#8c1dd0c"
          },
          
      ];

      const labelsMock = ["14/6", "15/6", "16/6", "17/6", "18/6", "19/6", "20/6"];
      const mock = {
          labels: labelsMock,
          datasets: datasetsMock
      }

      if (customerInformation.siem === "wazuh") {
          return (
              <Widget
                  header={t("logsPerDayWidgetTitle")}
                  onReload={this.onReload}
              >
                  <WidgetOverlayLinkToTa buttonText={t("logInToTa")} taUrl={customerInformation.technicalAnalysisUrl} />
                  <div className="bar-chart">
                      <Bar data={mock} options={options} />
                  </div>
              </Widget>
          );
      }

    if (isLoading) {
      return (
        <Widget
          header={t("logsPerDayWidgetTitle")}
          isLoading={isLoading}
          onReload={this.onReload}
        >
          <div className="pie-wrapper align-center">
            <div className="text-center">
              <Spinner />
            </div>
          </div>
        </Widget>
      );
      }

     

    if (hasErrors) {
      return (
        <Widget header={t("logsPerDayWidgetTitle")}>
          <div className="overlay overlay-default">
            <WidgetErrorMessage onClick={this.onReload} />
          </div>
        </Widget>
      );
    } else {
      return (
        <Widget header={t("logsPerDayWidgetTitle")} onReload={this.onReload}>
          <div className="bar-chart">
            <Bar data={logsPerDay} options={options} />
          </div>
          <div
            className={`warning-container ${
              logsPerDay.isLogLimitReached ? "show" : "hide"
            }`}
          >
            <i className="icon-fixed-width fa fa-warning text-critical fa-1" />
            {t("logsPerDayLogSpaceWarningTitle")}:{" "}
            <span className="text-strong">
              {logsPerDay.logSpaceThresholdPerDayGb}
              {t("logsPerDayLogSpaceWarningSpaceSuffix")}
            </span>{" "}
            {t("logsPerDayLogSpaceWarningText")}
          </div>
        </Widget>
      );
    }
  }
}

LogsDayWidget.propTypes = {
  actions: PropTypes.object.isRequired,
  logsPerDay: PropTypes.object.isRequired,
  isLoading: PropTypes.bool.isRequired,
  hasErrors: PropTypes.bool.isRequired,
  customerInformation: PropTypes.object.isRequired,
};

const mapStateToProps = state => {
  return {
    hasErrors: getLogsPerDayHasErrors(state),
    logsPerDay: getLogsPerDay(state),
    isLoading: getLogsPerDayIsLoading(state),
    customerInformation: state.customerInformation
  };
};

const mapDispatchToProps = dispatch => {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
};

export default translate("translations")(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LogsDayWidget)
);



// WEBPACK FOOTER //
// ./src/dashboard/widgets/LogsDayWidget.js